var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMeetingCommentsBgBlack(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 52 52",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_14",
    "data-name": "Layer 14"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,26A26,26,0,1,1,26,52,26,26,0,0,1,0,26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M35,19.27V29.36a2.23,2.23,0,0,1-2.25,2.22H27.69L23.3,34.87a.43.43,0,0,1-.68-.34v-3H19.25A2.25,2.25,0,0,1,17,29.36V19.27a2.23,2.23,0,0,1,2.25-2.22h13.5A2.23,2.23,0,0,1,35,19.27Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMeetingCommentsBgBlack);
export default __webpack_public_path__ + "static/media/meeting-comments-bg-black.c362cf0d2ae731337107aa22f69220a1.svg";
export { ForwardRef as ReactComponent };